// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"

// A save on the same screen must not close the panel the person is using.
document.addEventListener("turbo:before-render", (event) => {
  const nextBody = event.detail.newBody
  if (nextBody.dataset.pagePath !== document.body.dataset.pagePath) return

  document.querySelectorAll("details[id][open]").forEach((panel) => {
    nextBody.querySelector(`#${CSS.escape(panel.id)}`)?.setAttribute("open", "")
  })
})
